export default "__VITE_ASSET__$IUTSgOO__"